/**
 * Suspended Account Modal Component
 * Shows when an admin account has been suspended
 */

import React from 'react';
import { useAuth } from '../../store/AuthContext';
import './SuspendedModal.css';

interface SuspendedModalProps {
  isOpen: boolean;
}

const SuspendedModal: React.FC<SuspendedModalProps> = ({ isOpen }) => {
  const { logout } = useAuth();

  if (!isOpen) return null;

  const handleOk = async () => {
    try {
      await logout();
      // Force navigation even if logout doesn't navigate
      window.location.href = '/login';
    } catch (error) {
      console.error('Logout failed:', error);
      // Force logout even if API call fails
      window.location.href = '/login';
    }
  };

  return (
    <div className="modal-overlay suspended-overlay">
      <div className="modal-content suspended-modal">
        <div className="suspended-icon">🚫</div>
        <h2>Your account has been suspended</h2>
        <p>Your admin account has been disabled by a Master Admin. Please contact support for more information.</p>
        <button className="button-primary" onClick={handleOk}>
          OK
        </button>
      </div>
    </div>
  );
};

export default SuspendedModal;

